export const goal21 = {
  title: '21e eeuwse vaardigheden (SLO)',
  color: 'white',
  colorScale: ['#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99'],
  children: {
    'informatie': {
      children: {
        'comp': {
          title: 'Computational thinking',
          isLeaf: true,
          children: {
            'comp.formuleren': 'Probleem herformuleren',
            'comp.data': 'Gegevens verzamelen',
            'comp.decompositie': 'Probleemdecompositie',
            'comp.auto': 'Automatisering',
            'comp.proc': 'Algoritmes en procedures',
            'comp.parallel': 'Parallelisatie',
            'comp.abstract': 'Abstractie',
            'comp.simulatie': 'Simulatie en modellering'
          }
        },
        'ict': {
          title: 'ICT-basisvaardigheden',
          isLeaf: true,
          children: {
            'ict.basis': 'Basisbegrippen ICT',
            'ict.infra': 'Infrastructuur technologie',
            'ict.standaard': 'Standaardtoepassingen',
            'ict.veiligheid': 'Veiligheid',
            'ict.media': 'Creëren en publiceren van media'
          }
        },
        'inf': {
          title: 'Informatievaardigheden',
          isLeaf: true,
          children: {
            'inf.formuleren': 'Informatieprobleem formuleren',
            'inf.strategie': 'Zoekstrategieën bepalen',
            'inf.data': 'Verwerven en selecteren van informatie',
            'inf.verwerken': 'Verwerken van informatie',
            'inf.presenteren': 'Presenteren van informatie',
            'inf.evalueren': 'Evalueren en beoordelen'
          }
        },
        'media': {
          title: 'Mediawijsheid',
          isLeaf: true,
          children: {
            'media.samenleving': 'Medialisering van de samenleving',
            'media.beeldvorming': 'Media en beeldvorming',
            'media.id': 'Media, identiteit en participatie'
          }
        }    
      }
    },
    'denken': {
      children: {
        'creatief': {
          title: 'Creatief denken',
          isLeaf: true,
          children: {
            'crea.orienteren': 'Oriënteren',
            'crea.onderzoeken': 'Onderzoeken',
            'crea.uitvoeren': 'Uitvoeren',
            'crea.evalueren': 'Evalueren',
            'crea.reflecteren': 'Reflecteren'
          }
        },
        'kritisch': {
          title: 'Kritisch denken',
          isLeaf: true,
          children: {
            'krit.interpreteren': 'Interpreteren',
            'krit.analyseren': 'Analyseren',
            'krit.evalueren': 'Evalueren',
            'krit.concluderen': 'Concluderen',
            'krit.uitleggen': 'Uitleggen en beargumenteren',
            'krit.houding': 'Houding'
          }
        },
        'probleem': {
          title: 'Probleem oplossen',
          isLeaf: true,
          children: {
            'prob.proces': 'Probleemoplosprocessen',
            'prob.signaleren': 'Problemen signaleren',
            'prob.def': 'Problemen definiëren',
            'prob.analyseren': 'Problemen analyseren',
            'prob.opl': 'Oplossingen zoeken, bedenken, selecteren',
            'prob.realiseren': 'Een oplossing realiseren',
            'prob.eval': 'Evalueren van de oplossing'
          }
        },
        'zelf':  {
          title: 'Zelfregulering',
          isLeaf: true,
          children: {
            'zelf.orienteren': 'Oriënteren',
            'zelf.doelen': 'Doelen stellen',
            'zelf.plannen': 'Strategisch plannen',
            'zelf.controle': 'Zelfcontrole',
            'zelf.oordeel': 'Zelfbeoordeling'
          }
        }
      }  
    },
    'sociaal': {
      children: {
        'communicatie': {
          title: 'Communiceren',
          isLeaf: true,
          children: {
            'comm.boodschap': 'Boodschappen overbrengen en begrijpen',
            'comm.situaties': 'Omgaan met verschillende communicatieve situaties en communicatiepartners',
            'comm.middel': 'Communicatiemiddelen hanteren',
            'comm.tech': 'Gebruik maken van de mogelijkheden van ICT en technologie',
            'comm.houding': 'De leerling toont: zelfvertrouwen, vertrouwen in eigen communicatieve vaardigheid, betrokkenheid bij de ander en bij het onderwerp van communicatie, empathie, respect voor andere visies, uitingen en gedragingen'
          }
        },
        'samenwerken': {
          title: 'Samenwerken',
          isLeaf: true,
          children: {
            'samen.comm': 'Communiceren',
            'samen.taken': 'Taakuitvoering en (team)rollen',
            'samen.org': 'Organiseren',
            'samen.team': 'Werken in een team en houding'
          }
        },
        'sociaal': {
          title: 'Sociale & culturele vaardigheden',
          isLeaf: true,
          children: {
            'cult.reflecteren': 'Reflecteren op zichzelf in relatie tot de ander',
            'cult.inleven': 'Inlevingsvermogen en omgaan met verschillen',
            'cult.comm': 'Intercultureel communiceren en handelen'
          }
        }
      }
    }
  }
}